import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {ArticleDgSearchResults} from "../models/datagrid-search-results/article.dg-search-results.model";
import {ArticleService} from "../providers/article.service";

@Injectable()
export class ArticlesResolve implements Resolve<ArticleDgSearchResults> {
  constructor(private articleService: ArticleService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<ArticleDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.articleService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'DESC', 'created').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
